<template>
  <v-form ref="autenticacaoForm">
    <v-row>
      <v-col cols="12" md="12">
        <v-text-field
          v-model="funcionario.email"
          label="E-mail"
          outlined
          :rules="[
            () => $v.funcionario.email.required || 'Campo obrigatório',
            () => $v.funcionario.email.email || 'E-mail inválido'
          ]"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          label="Digite uma senha"
          outlined
          v-model="funcionario.senha"
          :type="!showPassword ? 'password' : 'text'"
          @click:append="showPassword = !showPassword"
          :append-icon="!showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :rules="[
            () => $v.funcionario.senha.required || 'Campo obrigatório',
            () => $v.funcionario.senha.minLength || 'Senha deve ter pelo menos 6 caracteres'
          ]"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          label="Confirme sua senha"
          outlined
          v-model="funcionario.confirmaSenha"
          :type="!showConfirmPassword ? 'password' : 'text'"
          @click:append="showConfirmPassword = !showConfirmPassword"
          :append-icon="!showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :rules="[
            () => $v.funcionario.confirmaSenha.required || 'Campo obrigatório',
            () => $v.funcionario.confirmaSenha.minLength || 'Senha deve ter pelo menos 6 caracteres',
            v => v === funcionario.confirmaSenha || 'As senhas não são iguais'
          ]"
        ></v-text-field>
      </v-col>
      <v-col cols="12" class="justify-space-between d-flex">
        <v-btn color="primary" large rounded @click="previousStep()">
          <v-icon>mdi-chevron-left</v-icon>
          Anterior
        </v-btn>
        <v-btn color="primary" :loading="loading" large rounded @click="nextStep()">
          Confirmar
          <v-icon>mdi-check</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minLength, email } from 'vuelidate/lib/validators'

export default {
  name: 'AutenticacaoForm',
  props: {
    value: {
      required: true
    },
    loading: {
      type: Boolean
    }
  },
  mixins: [validationMixin],
  validations: {
    funcionario: {
      email: {
        required,
        email
      },
      senha: {
        required,
        minLength: minLength(6)
      },
      confirmaSenha: {
        required,
        minLength: minLength(6)
      }
    }
  },
  computed: {
    funcionario: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  data() {
    return {
      showPassword: false,
      showConfirmPassword: false
    }
  },
  methods: {
    nextStep() {
      if (this.$refs.autenticacaoForm.validate()) {
        this.$emit('save-funcionario')
      }
    },
    previousStep() {
      this.$emit('previous-step')
    }
  }
}
</script>

<style></style>
